/* joechia-style language switcher for YA|SAR (v4 — places dropdown next to
 * every visible country switcher: desktop AND mobile drawer). */
(function () {
  'use strict';

  var LOCALES = {
    'en':    { label: 'EN',     native: 'English' },
    'ja':    { label: '日本語', native: '日本語' },
    'ko':    { label: '한국어', native: '한국어' },
    'zh-CN': { label: '中文',     native: '中文' },
    'de':    { label: 'DE',     native: 'Deutsch' },
    'fr':    { label: 'FR',     native: 'Français' }
  };

  var BANNER_TEXTS = {
    'ja': 'このサイトを日本語で表示しますか？',
    'ko': '이 사이트를 한국어로 표시할까요?',
    'zh-CN': '是否以中文显示此网站？',
    'de': 'Möchtest du diese Seite auf Deutsch ansehen?',
    'fr': 'Voulez-vous voir ce site en français ?'
  };

  function currentLocale() {
    var loc = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    loc = loc.replace('_', '-');
    var lower = loc.toLowerCase();
    for (var k in LOCALES) if (k.toLowerCase() === lower) return k;
    return 'en';
  }

  function cleanupOldInjects() {
    document.querySelectorAll('select.jc-locale-select').forEach(function (el) { el.remove(); });
  }

  function submitLocaleChange(targetLocale) {
    var url = window.location.pathname + window.location.search;
    var form = document.createElement('form');
    form.action = '/localization';
    form.method = 'POST';
    form.style.display = 'none';
    [
      ['_method', 'put'],
      ['locale_code', targetLocale],
      ['return_to', url],
      ['form_type', 'localization']
    ].forEach(function (kv) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = kv[0];
      i.value = kv[1];
      form.appendChild(i);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function createDropdown(anchorEl, instanceIdx) {
    var current = currentLocale();
    var wrap = document.createElement('div');
    wrap.className = 'jc-lang-switcher';
    wrap.setAttribute('data-jc-lang-idx', String(instanceIdx));
    wrap.style.cssText = 'position:relative;display:inline-block;margin-right:18px;font-family:inherit;font-size:14px;line-height:24px;cursor:pointer;user-select:none;vertical-align:middle;';

    var current_loc = LOCALES[current] || LOCALES.en;
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'jc-lang-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.style.cssText = 'background:none;border:none;color:inherit;font:inherit;cursor:pointer;padding:0 4px;display:inline-flex;align-items:center;gap:4px;letter-spacing:0.05em;';
    trigger.innerHTML = '<span class="jc-lang-label">' + current_loc.label + '</span><span class="jc-lang-caret" style="font-size:9px;opacity:0.6;transition:transform 0.2s;">▾</span>';

    var list = document.createElement('ul');
    list.className = 'jc-lang-list';
    list.setAttribute('role', 'listbox');
    list.style.cssText = 'position:absolute;top:100%;right:0;margin:0;padding:8px 0;list-style:none;background:#fff;color:#020202;border:1px solid #eee;min-width:140px;box-shadow:0 8px 24px rgba(0,0,0,0.08);opacity:0;visibility:hidden;transform:translateY(-4px);transition:opacity 0.2s ease,transform 0.2s ease,visibility 0.2s;z-index:9999;text-align:left;';

    Object.keys(LOCALES).forEach(function (code) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('data-locale', code);
      var isActive = code === current;
      li.style.cssText = 'padding:8px 16px;cursor:pointer;font-size:13px;letter-spacing:0.05em;transition:background 0.15s ease;' + (isActive ? 'font-weight:500;' : 'opacity:0.7;');
      li.textContent = LOCALES[code].native;
      li.addEventListener('mouseenter', function () { li.style.background = '#f5f5f5'; });
      li.addEventListener('mouseleave', function () { li.style.background = 'transparent'; });
      li.addEventListener('click', function (e) {
        e.stopPropagation();
        if (code === current) { close(); return; }
        submitLocaleChange(code);
      });
      list.appendChild(li);
    });

    function open() {
      list.style.opacity = '1';
      list.style.visibility = 'visible';
      list.style.transform = 'translateY(0)';
      trigger.setAttribute('aria-expanded', 'true');
      trigger.querySelector('.jc-lang-caret').style.transform = 'rotate(180deg)';
    }
    function close() {
      list.style.opacity = '0';
      list.style.visibility = 'hidden';
      list.style.transform = 'translateY(-4px)';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.querySelector('.jc-lang-caret').style.transform = 'rotate(0deg)';
    }
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (trigger.getAttribute('aria-expanded') === 'true') close();
      else open();
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    wrap.appendChild(trigger);
    wrap.appendChild(list);
    return wrap;
  }

  function buildDropdowns() {
    var anchors = Array.from(document.querySelectorAll('.m-country-switcher, .m-switcher-dropdown'));
    // Filter to unique anchors that don't already have a sibling .jc-lang-switcher
    anchors.forEach(function (anchor, i) {
      if (!anchor.parentElement) return;
      // Skip if already injected as previous sibling
      var prev = anchor.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('jc-lang-switcher')) return;
      var node = createDropdown(anchor, i);
      anchor.parentElement.insertBefore(node, anchor);
    });
  }

  function detectAndSuggest() {
    try {
      if (localStorage.getItem('jc_lang_dismissed')) return;
    } catch (e) { return; }
    var browserLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
    var base = browserLang.split('-')[0];
    var map = { 'ja': 'ja', 'ko': 'ko', 'de': 'de', 'fr': 'fr' };
    var detected = map[base];
    if (browserLang === 'zh-cn' || base === 'zh') detected = 'zh-CN';
    if (!detected) return;
    if (currentLocale().toLowerCase() === detected.toLowerCase()) return;
    showBanner(detected);
  }

  function showBanner(targetLocale) {
    if (document.getElementById('jc-lang-banner')) return;
    var bar = document.createElement('div');
    bar.id = 'jc-lang-banner';
    bar.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:99999;background:#020202;color:#fff;padding:16px 20px;font-family:inherit;font-size:14px;line-height:1.5;max-width:340px;letter-spacing:0.02em;box-shadow:0 8px 32px rgba(0,0,0,0.2);transform:translateY(20px);opacity:0;transition:opacity 0.4s ease,transform 0.4s ease;';
    var text = document.createElement('div');
    text.textContent = BANNER_TEXTS[targetLocale] || ('View this site in ' + (LOCALES[targetLocale] && LOCALES[targetLocale].native) + '?');
    text.style.marginBottom = '12px';
    bar.appendChild(text);
    var actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:16px;align-items:center;';
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = (LOCALES[targetLocale] && LOCALES[targetLocale].label) || targetLocale;
    yes.style.cssText = 'background:#fff;color:#020202;border:none;padding:8px 18px;font-family:inherit;font-size:13px;cursor:pointer;letter-spacing:0.1em;text-transform:uppercase;';
    yes.addEventListener('click', function () {
      try { localStorage.setItem('jc_lang_dismissed', '1'); } catch (e) {}
      submitLocaleChange(targetLocale);
    });
    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = '×';
    no.setAttribute('aria-label', 'Dismiss');
    no.style.cssText = 'background:none;border:none;color:#fff;font-size:20px;cursor:pointer;padding:0 4px;opacity:0.6;';
    no.addEventListener('click', function () {
      try { localStorage.setItem('jc_lang_dismissed', '1'); } catch (e) {}
      bar.style.opacity = '0';
      bar.style.transform = 'translateY(20px)';
      setTimeout(function () { bar.remove(); }, 400);
    });
    actions.appendChild(yes);
    actions.appendChild(no);
    bar.appendChild(actions);
    document.body.appendChild(bar);
    requestAnimationFrame(function () {
      bar.style.opacity = '1';
      bar.style.transform = 'translateY(0)';
    });
  }

  function init() {
    cleanupOldInjects();
    buildDropdowns();
    setTimeout(detectAndSuggest, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function () {
    cleanupOldInjects();
    buildDropdowns();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
